import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
/*  importing lists of years, best insurance quotes, countries names and codes,
    and some other data before adding them into the state of vuex */
import { QUOTES_INSURANCE } from '../data/quotes'
import { COUNTRIES } from '../data/countries'
import { YEARS } from '../data/years'
import { INPUT_RADIO_OFFICIAL_RULES, INPUT_RADIO_GENDER, INPUT_CHECKBOX_USAGE, INPUT_RADIO_MARITAL_STATUS, INPUT_RADIO_OWNERSHIP_STATUS, INPUT_RADIO_TITLE, INPUT_RADIO_TYPE_COVER, INPUT_RADIO_TYPE_HOME } from '../data/forms'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  // Defining some states of the store
  state: {
    quotes: QUOTES_INSURANCE,
    countries: COUNTRIES,
    years: YEARS,
    officialRules: INPUT_RADIO_OFFICIAL_RULES,
    gender: INPUT_RADIO_GENDER,
    usage: INPUT_CHECKBOX_USAGE,
    maritalstatus: INPUT_RADIO_MARITAL_STATUS,
    ownershipstatus: INPUT_RADIO_OWNERSHIP_STATUS,
    title: INPUT_RADIO_TITLE,
    typecover: INPUT_RADIO_TYPE_COVER,
    typehome: INPUT_RADIO_TYPE_HOME,
    invalidFormAlert: function () {
      return alert('Please fill up all required field with correct values !')
    },
    token: null,
    email: null,
    user: null,
    idUser: null
  },
  mutations: {
    // the following mutation is used to store the token and email in the state of vuex
    authUser (state, userData) {
      state.token = userData.token
      state.email = userData.email
    },
    // the following mutation is used to store user data in the state of vuex
    storeUser (state, user) {
      state.user = user
      state.idUser = user.id
    },
    // the following mutation is used to remove the token and email from the state of vuex
    clearAuthData (state) {
      state.token = null
      state.email = null
    }
  },
  actions: {
    // the following action is used to log out user after a certain time of inactivity
    setLogoutTimer ({commit}, expirationTime) {
      setTimeout(() => {
        commit('clearAuthData')
        router.replace('/login')
      }, expirationTime)
    },
    // the following action is used to post new user data to the restapi
    sign_up ({commit, dispatch}, authData) {
      return axios.post('users/', authData)
        .then(res => {
          console.log(res)
          dispatch('storeUser', authData)
          return res.status === 201
        })
        .catch(error => console.log(error))
    },
    /*  The following action is used to send a post request to the rest api to check if user exist or not.
        If user exists the token and email address received are saved to the store */
    sign_in ({commit, dispatch}, authData) {
      return axios.post('login/', authData)
        .then(res => {
          console.log(res)
          commit('authUser', {
            token: res.data.token,
            email: authData.username
          })
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('email', authData.username)
          // call setLogoutTimer action to logout user after 3 hours
          dispatch('setLogoutTimer', 10800000)
          return res.status === 200
        })
        .catch(error => console.log(error))
    },
    // The following action is used to sign out user
    sign_out ({commit}) {
      commit('clearAuthData')
      localStorage.removeItem('token')
      localStorage.removeItem('email')
      router.replace('/login')
    },
    /* The following action is used to log in user automatically
       if his token and email still exist in the api storage */
    autoLogin ({commit, state}) {
      const token = localStorage.getItem('token')
      const email = localStorage.getItem('email')
      if (!token && !email) return
      commit('authUser', {
        token: token,
        email: email
      })
    },
    // the following action is used to fetch user data from his email address
    fetchUserByEmail ({commit, state}) {
      if (!state.token) return
      axios.get('users/?search=' + state.email)
        .then(res => {
          const users = res.data
          console.log(users)
          commit('storeUser', users[0])
          state.idUser = users[0].id
        })
        .catch(error => console.log(error))
    },
    // the following action is used to fetch insurance data of a user from his email address registered
    fetchInsuranceByUser ({commit, state}) {
      if (!state.token) return
      return axios.get('insurances/?search=' + state.email)
        .then(res => {
          console.log(res)
          return res.data
        })
        .catch(error => console.log(error))
    },
    // the following action is used to update user profile data
    updateUserProfile ({commit, state}, userProfileData) {
      if (!state.token) return
      const config = {headers: {Authorization: 'Token ' + state.token}}
      return axios.put('users/' + state.idUser + '/', userProfileData, config)
        .then(res => res.status === 200)
        .catch(error => console.log(error))
    },
    // the following action is used to post new insurance data of user
    postInsurance ({commit, state}, insuranceData) {
      if (!state.token) return
      // const config = { headers: {Authorization: 'Token ' + state.token} }
      const config = { headers: {Authorization: 'Token 132651586181879eb08490d9a3dda67b92aef9a2'} }
      console.log(config)
      console.log('token : ' + state.token)
      return axios.post('insurances/', insuranceData, config)
        .then(res => res.status === 201)
        .catch(error => console.log(error))
    }
  },
  getters: {
    // Get all user data
    user (state) {
      return state.user
    },
    // Get user email address
    email (state) {
      return state.email
    },
    // Check if user has been logged in or not and return false or true respectively
    isAuthenticated (state) {
      return state.token !== null
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js